import React from "react";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { HardnessItem } from "../../forms/custom-hardness/hardnessResultSummaryForm";
import { getChunkedData } from "../../../utils/utilities";
import { Column } from "../../../utils/models";

import { useAppSelector } from "../../../store/configureStore";
import { getReportDetails } from "../../../store/reportDetails";

interface Props {
    hardnessResultItems: HardnessItem[];
}

const HardnessResultSummary: React.FC<Props> = ({ hardnessResultItems }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    return ( 
        <React.Fragment>
            {getChunkedData(hardnessResultItems, itemCountPerPage).map((datum, index) => (
                <CustomSection key={index} sectionTitle="Result Summary" >
                    <div className="p-1">
                        <PDFTablePage data={datum} columns={columns} />
                    </div>
                </CustomSection>
            ))}
        </React.Fragment>
     );
};

const columns: Column[] = [
    {
        path: 'id',
        label: 'Sr. No',
    },
    {
        path: 'item',
        label: 'ITEM',
    },
    {
        path: 'location',
        label: 'LOCATION OF TEST',
    },
    {
        path: 'minimum',
        label: 'MINIMUM',
        content: (item: HardnessItem) => <span>{Math.min(...item.readings.map((reading) => reading.value))}</span>,
    },
    {
        path: 'maximum',
        label: 'MAXIMUM',
        content: (item: HardnessItem) => <span>{Math.max(...item.readings.map((reading) => reading.value))}</span>,
    },
    {
        path: 'average',
        label: 'AVERAGE',
        content: (item: HardnessItem) => <span>{(item.readings.reduce((a, b) => a + b.value, 0) / item.readings.length).toFixed(2)}</span>,
    },
    {
        path: 'result',
        label: 'RESULT',
    },
];
 
export default HardnessResultSummary;